import PurchaseOrderItem from "./purchase-order-item";
import Decimal from "decimal.js";

/**
 * 発注項目のリスト
 */
export default class PurchaseOrderItems {
  private items: PurchaseOrderItem[] = [];

  public constructor(...items: PurchaseOrderItem[]) {
    this.items = items;
  }

  public get totalPrice(): Decimal {
    return this.items
      .map(i => i.price)
      .reduce((s, p) => s.plus(p), new Decimal(0));
  }

  public get totalLoss(): Decimal {
    return this.items
      .map(i => i.loss)
      .reduce((s, p) => s.plus(p), new Decimal(0));
  }

  public isEmpty(): boolean {
    return this.items.length === 0;
  }

  public toJSON(): any[] {
    return this.items.map(i => i.toJSON());
  }
}
